import React, { useEffect, useState } from "react";
import {
  useAddRoles,
  useGetRolesPermission,
  useUpdateRoles,
} from "../SuperSettingsScreen/hook/useSuperSetting";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import RouteDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { useGetSGPIStatus } from "../../sgpi/hooks/useSGPI";
import { showToast } from "../../../utils/toastUtils";

type Props = {};

const RolesModalContent = ({
  setIsModalOpen,
  setSelectedRow,
  setModalStatus,
  selectedRow,
  modalStatus,
}: {
  setIsModalOpen: any;
  setSelectedRow: any;
  setModalStatus: any;
  selectedRow: any;
  modalStatus: any;
}) => {
  // console.log(
  //   "🚀 ~ RolesModalContent.tsx:25 ~ RolesModalContent ~ selectedRow:",
  //   selectedRow
  // );

  const [formValues, setFormValues] = useState({
    roleName: "",
    roleDescription: "",
    keepPrivate: "",
  });
  const [enabledPermissions, setEnabledPermissions] = useState<string[]>([]);

  const { data: rolesPermissionListData } = useGetRolesPermission({
    enable: true,
  });

  const { mutate: addRoles } = useAddRoles();
  const { mutate: updateRoles } = useUpdateRoles();

  // ============= Keep private =============================
  const { data: statusSGPIData } = useGetSGPIStatus({
    enable: true,
  });

  //============== Formated Dropdown Data====================

  const formattedSGPIStatusData = Object.entries(
    statusSGPIData?.data?.Status || {}
  ).map((item: any) => ({
    id: item[0],
    label: item[1],
  }));

  // ==================useEffect for the edit =====================

  useEffect(() => {
    if (selectedRow && modalStatus === "Edit") {
      const formattedPermissionData = selectedRow?.RolePermissions.split(",");

      setFormValues({
        roleName: selectedRow?.RoleName,
        roleDescription: selectedRow?.RoleDesc,
        keepPrivate: selectedRow?.RolePrivate === true ? "Active" : "Inactive",
      });
      setEnabledPermissions(formattedPermissionData);
    }
  }, [selectedRow]);

  // ================ Input Function ===================
  const handleInputChange = (
    name: any,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = e.target;

    // Convert specific fields to numbers
    const numericFields = ["attachment", "leavePoints"];
    const updatedValue = numericFields.includes(name)
      ? value.replace(/[^0-9]/g, "")
      : value;

    setFormValues((prevState) => ({
      ...prevState,
      [name]: numericFields.includes(name)
        ? updatedValue === ""
          ? ""
          : Number(updatedValue)
        : updatedValue,
    }));
  };

  //================= Dropdown Function ======================
  const handleDropdownSelect = (field: string, value?: any) => {
    setFormValues((prevState) => ({
      ...prevState,
      [field]: value, // Directly assign the selected value
    }));
  };

  // ================== Checkbox handler Function =======================
  const handleCheckboxChange = (permKey: string, checked: boolean) => {
    setEnabledPermissions((prev) =>
      checked ? [...prev, permKey] : prev.filter((key) => key !== permKey)
    );
  };

  //================== Handle Submit ==================================
  const handleSubmit = () => {
   
    let addRolesBody;
    if (modalStatus === "Add") { 
      if(formValues.roleName !=""&&formValues.roleDescription !=""){
      addRolesBody = {
        RoleName: formValues?.roleName,
        RoleDesc: formValues?.roleDescription,
        RolePrivate: formValues?.keepPrivate,
        RolePermissions: enabledPermissions,
      };
      }
      else{
         showToast.warning('fill the Mendatory Field'); 
      }
  
      // console.log(
      //   "🚀 ~ RolesModalContent.tsx:88 ~ handleSubmit ~ addRolesBody:",
      //   addRolesBody
      // );

      addRoles(addRolesBody, {
        onSuccess: () => {
          setIsModalOpen(false);
          setFormValues({ roleName: "", roleDescription: "", keepPrivate: "" });
          setEnabledPermissions([]);
          setSelectedRow(null);
          setModalStatus("");
        },
        onSettled: () => {
          setIsModalOpen(false);
          setFormValues({ roleName: "", roleDescription: "", keepPrivate: "" });
          setEnabledPermissions([]);
          setSelectedRow(null);
          setModalStatus("");
        },
      });
    } else if (modalStatus === "Edit" && selectedRow) {
      const updateRolesBody = [
        {
          RoleId: selectedRow?.RoleId,
          RoleName: formValues?.roleName,
          RoleDesc: formValues?.roleDescription,
          RolePrivate: formValues?.keepPrivate,
          RolePermissions: enabledPermissions,
        },
      ];

      // console.log(
      //   "🚀 ~ RolesModalContent.tsx:155 ~ handleSubmit ~ updateRolesBody:",
      //   updateRolesBody
      // );
      // console.log(
      //   "🚀 ~ RolesModalContent.tsx:155 ~ handleSubmit ~ formValues?.keepPrivate:",
      //   formValues?.keepPrivate
      // );

      updateRoles(updateRolesBody, {
        onSuccess: () => {
          setIsModalOpen(false);
          setFormValues({ roleName: "", roleDescription: "", keepPrivate: "" });
          setEnabledPermissions([]);
          setSelectedRow(null);
          setModalStatus("");
        },
        onSettled: () => {
          setIsModalOpen(false);
          setFormValues({ roleName: "", roleDescription: "", keepPrivate: "" });
          setEnabledPermissions([]);
          setSelectedRow(null);
          setModalStatus("");
        },
      });
    }
  };

  return (
    <div>
      <div className="row mb-0">
        <div className="col-sm-4">
          <CustomInput
            required
            asterisk
            style={{borderRadius:'4px'}}
            label="Role Name"
            placeholder="Enter Role Name"
            type="text"
            name="roleName"
            value={formValues.roleName}
            onChange={(e) => handleInputChange("roleName", e)}
          />
        </div>
        <div className="col-sm-4">
          <CustomInput
            required
            asterisk   
            style={{borderRadius:'4px'}}
            label="Role Description"
            placeholder="Enter Role Description"
            type="text"
            name="roleDescription"
            value={formValues.roleDescription}
            onChange={(e) => handleInputChange("roleDescription", e)}
          />
        </div>
        <div className="col-sm-4">
          <RouteDropdown
            options={formattedSGPIStatusData || []}
            value={formValues?.keepPrivate}
            onChange={(value: any) => {
              handleDropdownSelect("keepPrivate", value);
            }}
            DropdownHeading="Keep Private"
            placeholder="Select Status"
          />
        </div>
      </div>
      <BasicDataTable
        Title="Roles Permission List"
        data={rolesPermissionListData?.data?.data || []}
        columns={RolesPermissionColumn(
          enabledPermissions,
          handleCheckboxChange
        )}
        search={false}
        headerContent={
          <button
            onClick={handleSubmit}
            className="btn btn-info"
            style={{
              borderRadius: "20px",
              padding: "6px 12px",
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <span>Save</span>
          </button>
        }
      />
    </div>
  );
};

export default RolesModalContent;

const RolesPermissionColumn = (
  enabledPermissions: any,
  handleCheckboxChange: (row: any, value: any) => void
) => [
  {
    name: "Enabled",
    cell: (row: { permKey: string }) => (
      <input
        type="checkbox"
        checked={enabledPermissions.includes(row.permKey)}
        onChange={(e) => handleCheckboxChange(row.permKey, e.target.checked)}
      />
    ),
    maxWidth: "33%",
  },
  {
    name: "Permission",
    selector: (row: { permKey: string }) => row.permKey || "-",
    sortable: true,
    maxWidth: "33%",
    wrap: true,
  },

  {
    name: "Description",
    selector: (row: { permDesc: boolean }) => row?.permDesc,
    sortable: true,
    maxWidth: "33%",
    wrap: true,
  },
];
